// src/components/sections/ValuesTopBanner.jsx - Updated with more appropriate icons
//this is the code of the "Our Value" section in the home page

import React from 'react';
import coreValuesData from '../../data/coreValuesData';
import ValueIcon from '../ui/ValueIcon';

/**
 * A compact banner displaying core values for use on the homepage
 */
const ValuesTopBanner = () => {
  return (
    <div className="bg-gray-50 py-6">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {coreValuesData.map((value, index) => (
            <div key={index} className="flex items-start group">
              <div className="text-secondary mr-4 flex-shrink-0 transition-transform duration-300 group-hover:scale-110">
                <ValueIcon icon={value.icon} className="h-8 w-8 text-secondary" />
              </div>
              <div>
                <h3 className="font-serif font-bold text-lg mb-2 text-primary">{value.title}</h3>
                <p className="text-gray-600 text-sm">{value.longDescription}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ValuesTopBanner;